import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "balance" }
const _hoisted_2 = { class: "balance-wrapper" }
const _hoisted_3 = { class: "balance-main" }
const _hoisted_4 = { class: "balance-main__title h3" }
const _hoisted_5 = { class: "balance-main__amount h1" }
const _hoisted_6 = { class: "balance-main__action" }

import BaseButton from "@/components/base/BaseButton.vue";
import { formatAmountInput } from "../../utils/format";

import { useStore } from "vuex";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'Balance',
  props: {
  amount: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



const store = useStore();
const { t } = useI18n();

const toPayment = () => {
  store.dispatch("togglePaymentModal", true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("account.balance.title")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_unref(formatAmountInput)(__props.amount)) + " ₽", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseButton, {
          title: _unref(t)('account.balance.topUp'),
          onClick: toPayment
        }, null, 8, ["title"])
      ])
    ])
  ]))
}
}

})